module.exports = __webpack_public_path__ + "img/focus_menu.e85811d3.svg";